import React from 'react'

import PropTypes from 'prop-types'
import { setPropTypes } from 'recompose'

const PureHtml = ({ html, className }) => (
  <div id="message " className={className} dangerouslySetInnerHTML={{ __html: html }} />
)

const enhance = setPropTypes({
  html: PropTypes.string.isRequired,
  className: PropTypes.string
})

export default enhance(PureHtml)
